import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction, IRequestExecutionContext, IResponseExecutionContext } from "@/Common/Stores/Actions/BaseAction";
import { FavoriteDiagnosisComposite } from "@/Patient/Models/MedicalSummary/FavoriteDiagnosisComposite";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";

class PatientMedicationTabActions extends BaseAction {
    constructor(onBeforeExecute?: IRequestExecutionContext, onBeforeHandleResponse?: IResponseExecutionContext) {
        super(onBeforeExecute, onBeforeHandleResponse);
    }

    public ToggleFavoriteMedicalProblem(DiagnosisId: string, FavoriteDiagnosis: FavoriteDiagnosisComposite, IsRemove: boolean, ReloadFavorites: boolean): void {
        this.Execute(ServerOperations.Server.Myle_ToggleFavoriteMedicalProblem, {
            DiagnosisId: DiagnosisId,
            IsRemove: IsRemove,
            ReloadFavorites: ReloadFavorites,
            FavoriteDiagnosis: FavoriteDiagnosis
        });
    }

    public UpsertMedication(medications: MedicationModel[], patientId: string, encounterId: string): void {
        var medicalItemMedicationAndPrescriptions = medications
            .filter(x => x != null)
            .map(y => y.Model);

        var requestData = {
            EncounterId: encounterId,
            PatientContactId: patientId,
            MedicalItemMedicationAndPrescriptions: medicalItemMedicationAndPrescriptions
        };

        return this.Execute(ServerOperations.Server.Myle_UpsertMedication, requestData);
    }

    public ReloadMedications(patientId: string): void {
        var requestData = {
            EMRTemplateType: 8, // Medication
            PatientContactId: patientId
        };
        return this.Execute(ServerOperations.Server.Myle_Patient_EMRTemplate_Get, requestData);
    }
}

export { PatientMedicationTabActions };
